export const environment = {
  production: true,
  apiUrl: 'https://membercare.wellkey.com.tw/api/', //PRD
  webUrl: 'https://membercare.wellkey.com.tw', //PRD
  downloadUrl: 'https://membercare.wellkey.com.tw', //PRD
  urlLength: 4, // 因HTTP與HTTPS會取不同長度, 所以特別設定
  baseUrl: '/prd/'
};
